<div>
  <mat-form-field>
    <mat-select name="type" placeholder="Type d'utilisateur" [(ngModel)]="role">
      @for (type of userTypes; track type) {
      <mat-option [value]="type">{{type}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button mat-button [disabled]="type" (click)="selectType()">Valider</button>
</div>
